import styled from '@emotion/styled';

/** Shared pieces of the six transposed-table variants (pre-save/exercise ×
 * base/SAQC/circuit). Only blocks that are byte-identical across all six
 * live here — variant-specific styles (RowValue, StepperButton, headers)
 * stay in their own files. */

/** Cell text colour: the textColor prop carries a theme token value
 * (textPlaceholder for empty cells), else body text. Usable directly as an
 * emotion interpolation: `color: ${mapLegacyTextColor};` */
export const mapLegacyTextColor = (props) => props.textColor || props.theme.colors.text;

export const StateBadge = styled('div')`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  height: 22px;
  padding: 0 8px;
  font-family: 'Nunito Sans';
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textMuted};
  background: ${({ theme }) => theme.colors.surfaceSecondary};
  border-radius: 11px;
  white-space: nowrap;
`;

export const SetsCountLabel = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
`;

/** Pill-style stepper: a single bordered group with -, number, + segments.
 * Buttons disable at the 1/10 floor and ceiling but the input remains
 * typeable for power users who want to jump straight to a value. */
export const SetsStepper = styled('div')`
  display: inline-flex;
  align-items: stretch;
  height: 32px;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.surfaceInput};
  overflow: hidden;
`;

/** Wrapper so the "# of Sets: 1-10" subtext sits under the stepper
 * without shifting it (subtext is taken out of flow). */
export const SetsFieldGroup = styled('div')`
  position: relative;
  display: inline-flex;
  align-items: center;
  /** Both groups this wraps — the stepper and the superset picker — are
   * fixed-size controls. They never compress. */
  flex-shrink: 0;
  gap: 5px;
`;

export const SetsSubtext = styled('div')`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  white-space: nowrap;
  font-family: 'Nunito Sans';
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;
